import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          center
        >
          <CFView textCenter column center w="90%">
            <CFImage
              w="100%"
              src={heroText}
              mt="-65px"
              ml="10px"
              alt="Kisso Sushi & Ramen Japanese Restaurant Logo Title"
            />
            <CFView mt="-15px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          center
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView column center w="100%" maxWidth="1400px">
            <CFImage
              h="500px"
              mt="-65px"
              src={heroText}
              alt="Kisso Sushi & Ramen Japanese Restaurant Logo Title"
            />
            <CFView mt="-45px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
